<template>
  <div id="feedback-user-select" v-if="allUsers">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="title">
              {{
                $t('feedback.modal.userSelect.title', {
                  userName: selectedUser ? selectedUser.userName : '-',
                })
              }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 no-gutters mt-2 mb-2">
            <base-input
              @baseInputValue="filter($event)"
              @enter="filter"
              type="text"
              :placeHolder="$t('feedback.modal.userSelect.filter.placeholder')"
              class="filter-input"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 user-image-list">
            <div
              class="profile-image-wrapper"
              v-for="(user, index) in filteredUser"
              :key="index"
            >
              <user-image
                :user="user"
                :class="`user-image ${userClasses(index)}`"
                :title="user.firstName + ' ' + user.lastName"
                @click.native="select(index)"
              />
              <div class="user-name">{{ user.userName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4 mt-4">
        <base-button
          @click="partnerKudos"
          :text="$t('feedback.modal.userSelect.kudosButtonText')"
          class="kudos-button"
        />
      </div>
      <div class="col-6 offset-2 mt-4">
        <base-button :disabled="!selectedUser" @click="next" text="Next" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseButton from '@/components/shared/elements/BaseButton';
import BaseInput from '@/components/shared/elements/BaseInput';
import UserImage from '@/components/shared/users/UserImage';
import KudosModal from '@/components/shared/modals/KudosModal';

export default {
  name: 'FeedbackUserSelect',
  components: {
    BaseButton,
    BaseInput,
    UserImage,
  },
  data() {
    return {
      selectedUserIndex: undefined,
      filteredUser: [],
    };
  },
  async created() {
    this.filteredUser = await this.fetchUsers();
    this.$gtag.event('feedbackUserSelect');
  },
  computed: {
    ...mapGetters({
      allUsers: 'users/users',
    }),
    selectedUser() {
      return this.filteredUser[this.selectedUserIndex];
    },
  },
  methods: {
    ...mapActions({
      fetchUsers: 'users/fetchUsers',
    }),
    userClasses(index) {
      let classes = '';
      if (index === this.selectedUserIndex) {
        classes += ' selected';
      }
      const user = this.allUsers[index];
      if (!this.filteredUser.includes(user)) {
        classes += ' filtered';
      }
      return classes;
    },
    filter(text) {
      this.filteredUser = this.allUsers.filter((x) => {
        return (
          x.email.toLowerCase().includes(text.toLowerCase()) ||
          x.userName.toLowerCase().includes(text.toLowerCase()) ||
          x.firstName.toLowerCase().includes(text.toLowerCase()) ||
          x.lastName.toLowerCase().includes(text.toLowerCase())
        );
      });
      this.selectedUserIndex = undefined;
    },
    select(index) {
      this.selectedUserIndex = index;
    },
    next() {
      this.$emit('showNext', this.selectedUser);
    },
    partnerKudos() {
       this.$eventBus.showModal({
        bind: {
          is: KudosModal,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#feedback-user-select {
  width: 450px;
  position: relative;
  .kudos-button {
    ::v-deep .base-button {
      background-color: #1dd1a1;
    }
  }
  @media (min-width: 992px) {
    width: 650px;
  }
  .title {
    margin-bottom: 10px;
  }
  .user-image-list {
    display: flex;
    flex-wrap: wrap;
    max-height: 350px;
    overflow: hidden;
    overflow-y: scroll;
    .user-name {
      text-align: center;
      font-size: 10px;
    }
  }
  .profile-image-wrapper {
    width: 60px;
    height: 60px;
    flex-grow: 0;
    margin: 10px;
    margin-bottom: 15px;
    cursor: pointer;
    ::v-deep img,
    ::v-deep .img {
      border: 2px solid transparent;
    }
    .selected {
      ::v-deep img,
      ::v-deep .img {
        border: 2px solid $primary-hover-color;
      }
    }
  }
}
</style>
